import API from './API.ts'

export default {
  getSettings () {
    return API.httpClient.get('booking-fields')
  },
  save (field) {
    return API.httpClient.post('booking-fields/save', field)
  },
  getForm (context) {
    return API.httpClient.post('booking-fields/form', context)
  },
  validateRegex ({ regex, sample }) {
    return API.httpClient.post('booking-fields/regex', {
      regex,
      sample
    })
  }
}
